import React from 'react'
import { authRoles } from '../../../auth/authRoles'
import InsuranceForm from './InsuranceForm'
import InsuranceView from './InsuranceView'
import Insurances from './Insurances'

const insuranceRoutes = [
    {
        path: '/insurances/add',
        element: <InsuranceForm />,
        auth: authRoles.admin,
    },
    {
        path: '/insurances/edit/:uuid',
        element: <InsuranceForm />,
        auth: authRoles.admin,
    },
    {
        path: '/insurances/view/:uuid',
        element: <InsuranceView />,
        auth: authRoles.admin,
    },
    {
        path: '/insurances',
        element: <Insurances />,
        auth: authRoles.admin,
    },
]

export default insuranceRoutes
